module.exports = __webpack_public_path__ + "dist/img/deptbehav.2425685e.svg";